import { useQuery } from '@tanstack/react-query'
import { api } from './api.ts'

/**
 * Feature toggles resolvidos no SERVIDOR (SPEC-20260814-1144).
 *
 * A empresa recebe o mapa `codigo -> boolean` pronto e nunca avalia regra —
 * mesma razao do bundle de i18n: se cada plataforma resolvesse por conta
 * propria, web, mobile e desktop divergiriam.
 *
 * `staleTime` curto de proposito: um kill-switch desligado pelo admin deve
 * valer no proximo foco/refetch, nao dali a 15 minutos.
 */
export function useFeatureToggleBundle() {
  return useQuery({
    queryKey: ['feature-toggle-bundle'],
    queryFn: async () => (await api['feature-toggles'].bundle.$get()).json(),
    staleTime: 60 * 1000,
  })
}

/**
 * Valor efetivo de um toggle para o usuario logado.
 *
 * Fail-closed: enquanto o bundle carrega (ou se o codigo nao existe), retorna
 * `false` — e mais seguro a funcionalidade piscar para LIGADA do que aparecer
 * por acidente. A UI esconder algo NUNCA dispensa o guard da rota na API.
 */
export function useFeatureToggle(code: string): boolean {
  const bundle = useFeatureToggleBundle()
  return bundle.data?.toggles?.[code] ?? false
}
